export const BASE_DATA_TYPES = {
  REMEDIATION_INCIDENT: 'REMEDIATION_INCIDENT',
  AUTOMATED_WORKFLOWS_EVENT: 'AUTOMATED_WORKFLOWS_EVENT',
  INSIGHTS_USER_SUBMISSION: 'INSIGHTS_USER_SUBMISSION',
  REMEDIATION_EMAIL: 'REMEDIATION_EMAIL'
}
